import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import { GET_ABSENCE_TYPES, SET_ABSENCE_TYPES } from "../actions/presence";
import { getVacationTypesApi } from "./vacation.api";

const getAuthState = state => state.auth;

function* fetchAbsenceTypes() {
  const authState = yield select(getAuthState);

  try {
    const types = yield call(getVacationTypesApi, authState.token);

    yield put({ type: SET_ABSENCE_TYPES, payload: types });
  } catch (e) {
    console.log("error", e.message);
  }
}

function* watchFetchAbsenceTypes() {
  yield takeLatest(GET_ABSENCE_TYPES, fetchAbsenceTypes);
}

export default function* root() {
  yield all([fork(watchFetchAbsenceTypes)]);
}



// WEBPACK FOOTER //
// src/modules/presence/sagas/absenceTypesSagas.js